import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';

declare global {
  interface Window {
    chatwootSettings: { darkMode: string };
    chatwootSDK: {
      run: (config: { websiteToken: string; baseUrl: string }) => void;
    };
    $chatwoot: {
      setUser: (id: string, attrs: { email?: string; name?: string }) => void;
      hasLoaded: boolean;
    };
  }
}

const ChatwootWidget: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const chatwootReady = useRef(false);

  useEffect(() => {
    const BASE_URL = 'https://chat.kolega.dev';

    window.chatwootSettings = {
      darkMode: 'auto',
    };

    const handleReady = () => {
      chatwootReady.current = true;
      if (isAuthenticated && user) {
        window.$chatwoot.setUser(user.id, {
          email: user.email,
          name: user.name || user.username,
        });
      }
    };

    window.addEventListener('chatwoot:ready', handleReady);

    const script = document.createElement('script');
    script.src = `${BASE_URL}/packs/js/sdk.js`;
    script.async = true;
    script.onload = () => {
      window.chatwootSDK.run({
        websiteToken: 'mYNmJUqEVvSiKZciBiPSr9Wv',
        baseUrl: BASE_URL,
      });
    };
    document.body.appendChild(script);

    return () => {
      window.removeEventListener('chatwoot:ready', handleReady);
      script.remove();
    };
  }, []);

  // Handle user login after widget is already ready
  useEffect(() => {
    if (!chatwootReady.current || !isAuthenticated || !user) return;

    window.$chatwoot.setUser(user.id, {
      email: user.email,
      name: user.name || user.username,
    });
  }, [isAuthenticated, user]);

  return null;
};

export default ChatwootWidget;
